module.exports = {
  // 数字千分化
  formatNum(num) {
    let value = 0;
    if (num) {
      value = (+num).toLocaleString();
    }
    return value;
  },
  // 格式化空值
  filterEmptyText(val) {
    return val || '-';
  }
};
